import { InputField } from 'lib/iterable-hook-form/FormField';
import { ErrorText } from 'modules/campaigns/editor/styles';
import { ScheduleFormState } from 'modules/campaigns/editor/types';
import { useFormState, useWatch } from 'react-hook-form';
import styled from 'styled-components';
import { FormField } from 'ui/formField';
import { colors, spacing } from 'ui/theme';
import { HelpToggletip, TipPlacement } from 'ui/tooltip';
import { pxToRem } from 'utils/convert';
import { SCHEDULE_CAMPAIGN_FORM_FIELDS } from '../ScheduleCampaignModal.constants';
import { RowWrapper } from '../ScheduleCampaignModal.styled';

export const PreCreateHourInputField = styled(InputField)`
  width: ${pxToRem(220)};
  input {
    width: ${spacing.base};
  }
`;

export const PreCreateHours = () => {
  const [precreateHours] = useWatch<Pick<ScheduleFormState, 'precreateHours'>>({
    name: ['precreateHours'],
  });

  const { errors } = useFormState<Pick<ScheduleFormState, 'precreateHours'>>({
    name: ['precreateHours'],
  });

  const { precreateHours: precreateHoursError } = errors;

  return (
    <FormField labelText="Create campaign">
      <RowWrapper>
        <PreCreateHourInputField
          data-test={SCHEDULE_CAMPAIGN_FORM_FIELDS.PRE_CREATE_HOURS}
          name="precreateHours"
          type="number"
          Suffix={
            <div>{parseInt(precreateHours, 10) === 1 ? 'hour' : 'hours'} ahead of send time</div>
          }
        />
        <HelpToggletip
          placement={TipPlacement.Right}
          tooltipContent="Select how much time you need to edit and review your message before Iterable sends the recurring campaign."
          iconProps={{ color: colors.secondaryText }}
        />
      </RowWrapper>

      {precreateHoursError?.message && <ErrorText>{precreateHoursError.message}</ErrorText>}
    </FormField>
  );
};
